export default {
  playerHdAudio: {
    height: '100%',
  },
};
